import { SubjectAccessFormView, SubjectAccessListView } from '@today/ui-domain'
import { complianceCapabilities } from '@/auth/compliance-capabilities'
import { useViewerPermissions } from '@/auth/useViewerPermissions'
import { useSubjectAccessForm, useSubjectAccessList } from '@/hooks/compliance/useSubjectAccessRequests'
import { ComplianceNav } from './ComplianceNav'

/** `/admin/compliance/sars` — subject access requests and their downloads (TO-232 compliance-admin-ui). */
export function ComplianceSarsPage() {
	const caps = complianceCapabilities(useViewerPermissions().permissions)
	const list = useSubjectAccessList()
	const form = useSubjectAccessForm()
	return (
		<div className="flex flex-col gap-6 p-6">
			<ComplianceNav />
			{caps.manageSars ? <SubjectAccessFormView {...form} /> : null}
			<SubjectAccessListView {...list} />
		</div>
	)
}
